import { List, ListItem, Typography } from "@material-ui/core";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import React, { Component } from "react";
import withFirebaseAuth from "react-with-firebase-auth";
import "./App.css";
import CommonButton from "./components/button/CommonButton";
import EmailButton from "./components/button/EmailButton";
import FacebookButton from "./components/button/FacebookButton";
import GoogleButton from "./components/button/GoogleButton";
import ButtonAppBar from "./components/ButtonAppBar";
import CustomizedInput from "./components/CustomizedInput";
import MaterialTableHelper from "./components/MaterialTableHelper";
import { decrypt } from "./CryptoUtilHelper";
import firebaseConfig from "./FirebaseConfig";
import Footer from "./components/Footer";

const firebaseApp = firebase.initializeApp(firebaseConfig);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: "",
      userData: [],
      inputPin: "",
      inputUsername: "",
      inputPassword: "",
      pin: "",
      ek: ""
    };
  }

  drawList(items) {
    return (
      <>
        {this.state.userData !== null && this.state.userData.length > 0 ? (
          <MaterialTableHelper items={items} ek={this.state.ek} userData={this.state.user} style={{ width: "100vh" }} />
        ) : null}
        {this.state.userData !== null && this.state.userData.length === 0 && this.state.pin !== "" ? (
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", alignContent: "center", marginTop: 20 }}>
            <Typography>You have not created any entries. Please use our Android app to create new entries.</Typography>
            <a
              href="https://play.google.com/store/apps/details?id=app.desmund.cloudpasswordmanager&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="Get it on Google Play" src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" width="200vh" />
            </a>
          </div>
        ) : null}
      </>
    );
  }

  getPin = input => {
    if (input.length > 0) {
      if (firebaseAppAuth.currentUser !== null && firebaseAppAuth.currentUser.uid !== null) {
        let uid = firebaseAppAuth.currentUser.uid;
        this.setState({ user: firebaseAppAuth.currentUser });
        let ref = firebaseApp.database().ref("/data/" + uid + "/1");
        ref.once("value", snapshot => {
          let p = decrypt(snapshot.val(), input);
          if (p === "CLOUD") {
            this.setState({ pin: input });
            this.getEK();
          }
        });
      }
    } else {
      alert("PIN cannot be empty");
    }
  };

  getEK = () => {
    let uid = firebaseAppAuth.currentUser.uid;
    let ref = firebaseApp.database().ref("/data/" + uid + "/0");
    ref.once("value", snapshot => {
      this.setState({ ek: decrypt(snapshot.val(), this.state.pin) });
      this.getUserData();
    });
  };

  getUserData = () => {
    let uid = firebaseAppAuth.currentUser.uid;
    let ref = firebaseApp.database().ref("/data/" + uid);
    ref.on("value", snapshot => {
      let data = [];
      this.setState({ userData: [] });
      snapshot.forEach(child => {
        if (this.state.ek !== "") {
          if (child.key !== "0" && child.key !== "1" && child.key !== "p" && child.key !== "v") {
            data.push(child);
          }
        } else {
          console.log("ek not retrieved");
        }
      });
      this.setState({ userData: data });
      this.drawList(data);
    });
  };

  getHash = () => {
    console.log(JSON.stringify(firebaseAppAuth.currentUser.uid));
    let uid = firebaseAppAuth.currentUser.uid;
    let ref = firebaseApp.database().ref("/data/" + uid + "/1");
    ref.on("value", snapshot => {
      const state = snapshot.val();
      console.log("hashed: " + JSON.stringify(state));
      console.log("decrypred : " + decrypt(state, "1"));
    });
    console.log("DATA RETRIEVED");
    // ff1e9d1bb7db58a3PEc+OHDlIVC0qmUyTCpJzg==
  };

  logout = () => {
    this.setState({ userData: [], pin: "", inputPin: "", ek: "" });
  };

  updateInputValue = evt => {
    this.setState({
      inputPin: evt.target.value
    });
  };
  updaterInputUsername = evt => {
    this.setState({
      inputUsername: evt.target.value
    });
  };
  updateInputPassword = evt => {
    this.setState({
      inputPassword: evt.target.value
    });
  };
  render() {
    const { user, signOut, signInWithGoogle, signInWithFacebook } = this.props;

    const signIn = () => {
      firebaseAppAuth.signInWithEmailAndPassword(this.state.inputUsername, this.state.inputPassword).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === "auth/wrong-password") {
          alert(
            "Wrong password or you may have registered using a Google or Facebook account.\nMake sure your password is correct or try to sign in with Google or Facebook option instead."
          );
        } else {
          alert(errorMessage);
        }
        console.log(error);
      });
    };

    return (
      <div>
        <ButtonAppBar user={user} signOut={signOut} logout={this.logout} />
        <div>
          {/* <header className="App-header"> */}
          <header>
            {user === null ? (
              // <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh" }}>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: 20 }}>
                <CustomizedInput label="Email" onChangeListener={this.updaterInputUsername} />
                <CustomizedInput label="Password" type="password" onChangeListener={this.updateInputPassword} />
                <Typography style={{ marginTop: 10 }} />
                <EmailButton click={signIn} />
                <GoogleButton click={signInWithGoogle} />
                <FacebookButton click={signInWithFacebook} />
                <Typography style={{ marginTop: 20 }}>CloudPass Web is currently in beta and not optimized for mobile</Typography>
                <Typography style={{ marginTop: 0 }}>To register an account or to maintain your existing data, please use our Android app.</Typography>
                <a
                  href="https://play.google.com/store/apps/details?id=app.desmund.cloudpasswordmanager&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img alt="Get it on Google Play" src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" width="200vh" />
                </a>
              </div>
            ) : null}
            {user !== null && this.state.pin === "" ? (
              <List style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                <ListItem style={{ justifyContent: "center" }}>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                    <Typography style={{ color: "#344955" }}>Please key-in your PIN</Typography>
                    <Typography style={{ color: "#344955" }}>This is the PIN that you have configured on your first-time login via our mobile app.</Typography>
                  </div>
                </ListItem>
                <ListItem style={{ justifyContent: "center" }}>
                  <CustomizedInput label="PIN" onChangeListener={this.updateInputValue} />
                </ListItem>
                <ListItem style={{ justifyContent: "center" }}>
                  <CommonButton
                    text="Confirm"
                    click={() => {
                      this.getPin(this.state.inputPin);
                    }}
                  />
                </ListItem>
              </List>
            ) : null}
            {this.drawList(this.state.userData)}
          </header>
          <Footer />
        </div>
      </div>
    );
  }
}

const firebaseAppAuth = firebaseApp.auth();

const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
  facebookProvider: new firebase.auth.FacebookAuthProvider(),
  emailProvider: new firebase.auth.EmailAuthProvider()
};

export default withFirebaseAuth({
  providers,
  firebaseAppAuth
})(App);
